import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { movieApi, handleApiError } from '../services/api';

type Status = 'verifying' | 'success' | 'error';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState<Status>('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('This verification link is missing its token.');
      return;
    }

    movieApi.verifyEmail(token)
      .then((response) => {
        if (response.success) {
          setStatus('success');
          setMessage(response.message || 'Your email has been verified. You can now sign in.');
        } else {
          setStatus('error');
          setMessage(response.error || 'This verification link is invalid or has expired.');
        }
      })
      .catch((err) => {
        setStatus('error');
        setMessage(handleApiError(err));
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="max-w-md mx-auto mt-16 p-6">
        <div className="bg-white rounded-lg shadow p-6 text-center">
          {status === 'verifying' && (
            <p className="text-gray-600">Verifying your email...</p>
          )}

          {status === 'success' && (
            <>
              <h1 className="text-xl font-bold text-gray-900 mb-3">You're verified!</h1>
              <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg mb-4">
                {message}
              </div>
              <Link to="/" className="text-blue-600 hover:text-blue-800 font-medium">
                Go to homepage to sign in
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <h1 className="text-xl font-bold text-gray-900 mb-3">Verification failed</h1>
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
                {message}
              </div>
              <p className="text-sm text-gray-600">
                You can request a new verification link the next time you try to sign in.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
